
import type { ResourceLogConfig } from '../interfaces/ResourceLogConfig';
import { LOG_LEVELS } from './LOG_LEVELS';
import { LOG_TRANSPORTS } from './LOG_TRANSPORTS';

/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Default logging configuration for resource-level settings</blockquote>
 * 
 * @remarks
 * Provides environment-specific default logging configuration.
 * Used when no explicit logging configuration is found in the resource hierarchy.
 * 
 * @example
 * ```typescript
 * const config = getResourceConfig('module.dashboard.data.page');
 * const loggingEnabled = config?.logs?.development ?? DEFAULT_LOGGING_CONFIG.development;
 * ```
 */
export const /**
 * @internal
 */
DEFAULT_LOGGING_CONFIG: ResourceLogConfig = {
  development: {
    level: LOG_LEVELS.INFO,
    transport: LOG_TRANSPORTS.CONSOLE,
  },
  preview: {
    level: LOG_LEVELS.INFO,
    transport: LOG_TRANSPORTS.CONSOLE,
  },
  production: {
    level: LOG_LEVELS.WARN,
    transport: LOG_TRANSPORTS.SENTRY,
  },
} as const;